import { ID, IDPrefixes, RelationshipUpdate, UpdateGoal } from '@griply/types';
import {
  buildLinkUpdates,
  createPrefixId,
  LinkDocumentSide,
  sameSet,
} from '@griply/utils';

export type BuildGoalLinkWritesOptions = {
  goalId: ID;
  lifeAreaIds: ID[];
  currentLifeAreaIds: ID[];
  // False until this goal's life areas have been written to its relationship document.
  isMigrated?: boolean;
};

export type GoalLinkWrites = {
  goalUpdate: UpdateGoal | null;
  relationshipUpdates: RelationshipUpdate[];
};

export const buildGoalLinkWrites = ({
  goalId,
  lifeAreaIds,
  currentLifeAreaIds,
  isMigrated = false,
}: BuildGoalLinkWritesOptions): GoalLinkWrites => {
  // An unmigrated goal's set lives in the legacy scalar only — the relationship doc holds nothing to diff against.
  const relationshipUpdates = buildLinkUpdates({
    linkingId: createPrefixId(goalId, IDPrefixes.Goal),
    targetPrefix: IDPrefixes.LifeArea,
    desiredIds: lifeAreaIds,
    currentIds: isMigrated ? currentLifeAreaIds : [],
    side: LinkDocumentSide.Linking,
  });

  if (
    !relationshipUpdates.length &&
    (isMigrated || sameSet(lifeAreaIds, currentLifeAreaIds))
  ) {
    return { goalUpdate: null, relationshipUpdates: [] };
  }

  return {
    // Goals carry no derived array — only the legacy scalar, which trails the set's first entry.
    goalUpdate: {
      id: goalId,
      lifeAreaId: lifeAreaIds[0] ?? null,
      ...(isMigrated ? {} : { lifeAreaLinksMigrated: true }),
    },
    relationshipUpdates,
  };
};
